import { connect } from 'react-redux'
import GroupsTable from './groups-table'
import { withRouter } from 'react-router-dom'
import {
  getSortedGroups,
  getSortBy,
  getSelectedGroups,
  isEveryoneSelected,
  isShowingSelected
} from '../groups-component-redux/groups-component-redux.selectors'
import {
  changeSortKey,
  selectAllGroups,
  deselectAllGroups,
  groupAction
} from '../groups-component-redux/groups-component-redux.actions'
import { getGroupsArray } from '../../../../stores/groups/groups.selectors'

const mapStateToProps = state => {
  const actualGroups = getGroupsArray(state)
  const filteredGroups = getSortedGroups(state)
  return {
    actualGroupsEmpty: !actualGroups.length,
    filteredGroupsEmpty: !!actualGroups.length && !filteredGroups.length,
    hideAllButton: isShowingSelected(state),
    groups: getSortedGroups(state),
    sortBy: getSortBy(state),
    selectedGroups: getSelectedGroups(state),
    everyoneSelected: isEveryoneSelected(state)
  }
}

const mapDispatchToProps = dispatch => ({
  changeSortKey: (key, direction) => dispatch(changeSortKey(key, direction)),
  dispatch
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onGroupClick: id => {
    dispatchProps.dispatch(groupAction(id))
    ownProps.history.push('/')
  },
  allAction: () => {
    return !stateProps.everyoneSelected
      ? dispatchProps.dispatch(selectAllGroups())
      : dispatchProps.dispatch(deselectAllGroups())
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(GroupsTable)
)
